import { MixedSchema } from ".."

export const mixed = <TValue = any>() => new MixedSchema<TValue>()
